import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Truck, Package, Clock, ArrowRight, Play } from 'lucide-react';

const Hero = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  return (
    <div className="relative bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h1 className="text-3xl sm:text-4xl text-gray-900 mb-4 sm:mb-6">
              Bienvenue chez <span className="font-bold text-black">Québec Alimentation!</span>
            </h1>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8">
              Chez Québec Alimentation, nous transformons votre expérience des viandes premium. En tant que service alimentaire privé, nous sommes fiers d'offrir des viandes de la plus haute qualité au meilleur prix possible.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-8">
              <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
                <Truck className="w-6 h-6 sm:w-8 sm:h-8 text-black mb-2" />
                <h3 className="font-semibold">Livraison Directe</h3>
                <p className="text-sm text-gray-600">De la ferme à votre porte</p>
              </div>
              <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
                <Package className="w-6 h-6 sm:w-8 sm:h-8 text-black mb-2" />
                <h3 className="font-semibold">Qualité Premium</h3>
                <p className="text-sm text-gray-600">Fraîcheur sous vide</p>
              </div>
              <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
                <Clock className="w-6 h-6 sm:w-8 sm:h-8 text-black mb-2" />
                <h3 className="font-semibold">Livraison Flexible</h3>
                <p className="text-sm text-gray-600">1-4 fois par année</p>
              </div>
            </div>
            <Link
              to="/booking"
              className="sm:w-auto bg-custom-red text-white px-6 py-2.5 rounded-full transition-colors text-base font-bold inline-flex items-center hover:bg-opacity-90"
            >
              REJOIGNEZ-NOUS
              <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
          <div className="relative mt-8 md:mt-0 flex justify-center">
            {!isVideoPlaying ? (
              <div
                className="relative w-full max-w-[476px] h-[476px] rounded-lg shadow-xl overflow-hidden cursor-pointer"
                onClick={() => setIsVideoPlaying(true)}
              >
                <img
                  src="/thumbnail.png"
                  alt="Video thumbnail"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <div className="bg-custom-red rounded-full p-4 transition-transform transform hover:scale-110">
                    <Play className="w-8 h-8 text-white" />
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                  <h3 className="text-white text-xl font-semibold">Experience Premium Quality Meats</h3>
                  <p className="text-white/80">Watch how we select and prepare our premium cuts</p>
                </div>
              </div>
            ) : (
              <video
                src="/video.mp4"
                autoPlay
                controls
                loop
                className="rounded-lg shadow-xl w-full max-w-[476px] h-[476px] object-cover"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
